import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  InspectionErrandProtocolSettingConfig,
  type InspectionErrandProtocolSetting,
} from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';

export const InspectionErrandProtocolSettingItem: RelationFieldProps<InspectionErrandProtocolSetting> =
  {
    nested: getRelationFieldNames(InspectionErrandProtocolSettingConfig),
    renderItem: (item) => {
      return {
        title: item.name ?? '',
        descriptionItems: (
          <div className='w-full font-medium'>
            <span>{item.customId ?? 'Inget objekts-id angivet'}</span>
          </div>
        ),
      };
    },
  };
